import styled from '@emotion/styled'

import { calcRem } from 'component-library/__styling/style-functions'

export interface Props {
    className?: string
    width: number
    height: number
    horizontalSpacing?: number | undefined
    fill: string
}

export const StyledVideoIcon = styled('svg')<Props>(props => ({
    width: calcRem(props.width),
    height: calcRem(props.height),
    marginLeft: props.horizontalSpacing && calcRem(props.horizontalSpacing),
    fill: props.fill,
}))
